/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateProcessFileDto
 */
export interface CreateProcessFileDto {
    /**
     * プロパティ（データ項目名）
     * @type {string}
     * @memberof CreateProcessFileDto
     */
    property: string;
    /**
     * ファイル名
     * @type {string}
     * @memberof CreateProcessFileDto
     */
    fileName: string;
}

/**
 * Check if a given object implements the CreateProcessFileDto interface.
 */
export function instanceOfCreateProcessFileDto(value: object): value is CreateProcessFileDto {
    if (!('property' in value) || value['property'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    return true;
}

export function CreateProcessFileDtoFromJSON(json: any): CreateProcessFileDto {
    return CreateProcessFileDtoFromJSONTyped(json, false);
}

export function CreateProcessFileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProcessFileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'property': json['property'],
        'fileName': json['fileName'],
    };
}

export function CreateProcessFileDtoToJSON(json: any): CreateProcessFileDto {
    return CreateProcessFileDtoToJSONTyped(json, false);
}

export function CreateProcessFileDtoToJSONTyped(value?: CreateProcessFileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'property': value['property'],
        'fileName': value['fileName'],
    };
}

